<template>
	<div  :style="`backgroundColor:${ui.bg_color};`" class="main_third_wrapper">
        <img src="../../assets/image/new_img/notice_2.png" alt="" class="notice_2">
        <!--  倒计时-->
        <vantCountDown></vantCountDown>
<!-- :class="[is_city ? 'main_form_third_01' : 'main_form_third_02', formHeightClass]" -->
        <div class="main_form main_form_third" 
              :class="custom_form + '_third'">
            <p v-if="is_name" class="lable_p mb_16">您的姓名</p>
            <van-field
                v-if="is_name"
                v-model="action_form.name"
                name="姓名"
                placeholder="请输入您的姓名"
                class="custom_field"
            />

            <p class="lable_p mb_16">您的手机号码(已加密)</p>
            <van-field
                type="tel"
                v-model="action_form.phone"
                name="电话"
                placeholder="请输入您的手机号码"
                class="custom_field"
            />

            <template v-if="is_show_car">
              <p class="lable_p mb_16">选择您的意向车型</p>
              <van-field
                  v-model="action_form.car_name"
                  readonly
                  placeholder="意向车型（品牌+厂商+车型）"
                  @click="openCarDialog"
                  class="custom_field"
                  :class="is_city==false ? 'mb_15' : ''"
              >
                <template slot="right-icon">
                  <van-icon name="play" style="transform: rotate(90deg)" color="#a0a4ac"/>
                </template>
              </van-field>
            </template>
            <!--          v-if="is_city"-->
            <p class="lable_p mb_16"  v-if="is_city">您所在的城市</p>
            <van-field
                v-if="is_city"
                v-model="action_form.city"
                readonly
                placeholder="选择您所在的城市"
                @click="openCityDialog"
                class="custom_field mb_15"
                style="margin-bottom: 2px;"
            >
              <template slot="right-icon">
                <van-icon name="play" style="transform: rotate(90deg)" color="#a0a4ac"/>
              </template>
            </van-field>

            <!--  按钮-->
            <div class="main_form_btn">

              <registNumber :type="5"></registNumber>
<!--              <div class="number_continer">-->
<!--                <img src="../../assets/image/new_img/number_bg_03.png" alt="">-->
<!--                <span>已有{{number_2}}人报名</span>-->
<!--              </div>-->
              <div class="form_btn" @click="submitForm" :class="is_stop ? '' : 'form_btn_light'"
                   :style="`backgroundColor: ${ui.btn_bg_color};`">
                <span :style="`color: ${is_opacity}`">{{ui.btn_text}}</span>
                <img src="../../assets/image/new_img/pointer_02.png" alt="" class="form_pointer finger_1" style="z-index: 20;">
              </div>
            </div>
            <!-- 协议-->
            <div class="form_policy">
              <policy :custom_col="'#2e2e2c'"></policy>
            </div>
          </div>
      </div>
</template>

<script>
  import policy from "@/components/policy";
	import vantCountDown from '../vantCountDown.vue';
	import registNumber from "@/components/registNumber";
	import remainTicket from "@/components/remainTicket";

export default {
	name: "formFive",
	components: {
		policy,
		vantCountDown,
		registNumber,
		remainTicket
	},
	data(){
		return{
      // is_name:true //是否显示姓名
		}
	},
	props: {
		ui: {
			type: Object,
		},
		is_opacity: {
			type: String,
		},
		is_city: {
			type: Boolean,
		},
		action_form: {
			type: Object,
		},
		is_stop: {
			type: Boolean,
		},
    is_show_car: {
      type: Boolean,
      default: true
    },
    tid:{
        type: Number,
        default: 0
      },
    title:{
      type: String,
      default: ''
    },
    is_name:{
      type: Boolean,
      default: true,
    },
    custom_wrap: {
      type: String,
      default: '',
    },
    custom_form: {
      type: String,
      default: '',
    },
  },
	methods: {
			submitForm(){
				this.$emit('submitForm')
			},
			 openCarDialog() {
        this.$emit("openCarDialog");
      },
      openCityDialog() {
        this.$emit("openCityDialog");
      },
		},
		 computed: {
      formHeightClass() {
        if (this.is_city && this.is_show_car) {
          return 'form-thrid-height-large'; // 4个字段
        } else if (this.is_city || this.is_show_car) {
          return 'form-thrid-height-medium'; // 3个字段
        } else {
          return 'form-thrid-height-small'; // 2个字段
        }
      },
      wrapHeightClass() {
        if (this.is_city && this.is_show_car) {
          return 'wrap-thrid-height-large'; // 4个字段
        } else if (this.is_city || this.is_show_car) {
          return 'wrap-thrid-height-medium'; // 3个字段
        } else {
          return 'wrap-thrid-height-small'; // 2个字段
        }
      }
    },
    
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/autoshow/base.less";
  @import "../../assets/style/autoshow/base_form.less";

  .form-thrid-height-large{
    height: 860px;
  }
  .form-thrid-height-medium{
    height: 730px;
  }
  .form-thrid-height-small{
    height: 600px;
  }
  
   .form-height-4_third{
    height: 860px;
  }
 .form-height-3_third{
    height: 730px;
  }
 .form-height-2_third{
     height: 600px;
  }
  .form-height-1_third{
     height: 470px;
  }
</style>